import {SSO_UNSUPPORTED_SITES_LIST} from "./constants";

const isSSOUnsupportedSite = (siteName) => {
    return SSO_UNSUPPORTED_SITES_LIST.includes(siteName);
}

const isVatEnabledCountry = (vatCountryDetails, countryCode) => {
    if (vatCountryDetails) {
        let vatCountryDetail = vatCountryDetails.find(vatCountry => vatCountry.countryCode === countryCode);
        if (vatCountryDetail) {
            return vatCountryDetail.allowTaxIdCollection && vatCountryDetail.taxType === 'VAT';
        }
    }
    return false;
}

export {
    isSSOUnsupportedSite,
    isVatEnabledCountry
}
